export const UMC_DEVICES = [
    {
        "umcSetType": "SIP",
        "stationType": "SIP_Extension",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALE-2",
        "stationType": "SIP_Extension",
        "stationSubType": "SIP_M1",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALE-3",
        "stationType": "SIP_Extension",
        "stationSubType": "SIP_ALE_3",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALE-20 SIP",
        "stationType": "SIP_Extension",
        "stationSubType": "NOE_C_COLOR_IP_ALE20",
        "progkeycategory": "SIP-xx"
    },
    {
        "umcSetType": "ALE-30 SIP",
        "stationType": "SIP_Extension",
        "stationSubType": "NOE_C_COLOR_IP_ALE30",
        "progkeycategory": "SIP-xx"
    },
    {
        "umcSetType": "ALE-300 SIP",
        "stationType": "SIP_Extension",
        "stationSubType": "NOE_C_COLOR_IP_ALE300",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALE-400 SIP",
        "stationType": "SIP_Extension",
        "stationSubType": "NOE_C_COLOR_IP_ALE400",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALE-500 SIP",
        "stationType": "SIP_Extension",
        "stationSubType": "NOE_C_COLOR_IP_ALE500",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "NOE",
        "stationType": "NOE_C_8039",
        "stationSubType": "SIP_DEFAULT"
    },
    {
        "umcSetType": "ALES Desktop",
        "stationType": "SIP_Extension",
        "stationSubType": "SIP_SOFTPHONE_DESKTOP",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALES Mobile",
        "stationType": "SIP_Extension",
        "stationSubType": "SIP_SOFTPHONE_MOBILE",
        "progkeycategory": "SIP-xxx"
    },
    {
        "umcSetType": "ALE-20",
        "stationType": "NOE_B_IP_ALE20",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-20h",
        "stationType": "NOE_B_ALE20H",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-20h tdm",
        "stationType": "NOE_B_ALE20H",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-20h ip",
        "stationType": "NOE_B_IP_ALE20H",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-30",
        "stationType": "NOE_C_COLOR_IP_ALE30",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-30h",
        "stationType": "NOE_C_ALE30H",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-30h ip",
        "stationType": "NOE_C_COLOR_IP_ALE30H",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-30h tdm",
        "stationType": "NOE_C_ALE30H",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Essential"
    },
    {
        "umcSetType": "ALE-300",
        "stationType": "NOE_C_COLOR_IP_ALE300",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Enterprise"
    },
    {
        "umcSetType": "ALE-400",
        "stationType": "NOE_C_COLOR_IP_ALE400",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Enterprise"
    },
    {
        "umcSetType": "ALE-500",
        "stationType": "NOE_C_COLOR_IP_ALE500",
        "stationSubType": "SIP_DEFAULT",
        "progkeycategory": "NOE Enterprise"
    },
    {
        "umcSetType": "IP DeskTop SoftPhone",
        "stationType": "NOE_C_COLOR_IP_8068s",
        "progkeycategory": "NOE_IPDSP"
    },
    {
        "umcSetType": "UA virtual",
        "stationType": "UA_VIRTUAL"
    },
    {
        "umcSetType": "8008",
        "stationType": "NOE_B_IP_8008"
    }
]

// export const NOE_ENTERPRISE_OPTION = [
//     { value: "ale-120-0", label: <>Without ALE-120<span className="radio-sub-info"> (Key expansion module)</span></> },
//     { value: "ale-120-1", label: <>1 x ALE-120<span className="radio-sub-info"> (multiple pages)</span></> },
//     { value: "ale-120-2", label: "2 x ALE-120" },
//     { value: "ale-120-3", label: "3 x ALE-120" }]


// export const NOE_ESSENTIAL_OPTION = [
//     { value: "em-200-0", label: <>Without EM200<span className="radio-sub-info"> (Key expansion module)</span></> },
//     { value: "em-200-1", label: <>1 x EM200<span className="radio-sub-info"> (multiple pages)</span></> },
//     { value: "em-200-2", label: "2 x EM200" },
//     { value: "em-200-3", label: "3 x EM200" }]